import React from 'react';
import { useSelector } from 'react-redux';
import { CircularProgress, Box, Typography } from '@mui/material';
import { selectLoading } from '../../redux/slices/authSlice';


/**
 * CacheProvider now relies on Redux auth state for loading state.
 * It only renders children when auth loading is false.
 */
const CacheProvider = ({ children }) => {
  const loading = useSelector(selectLoading);
  
  if (loading) {
    return (
      <Box 
        display="flex" 
        flexDirection="column"
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Loading user data...
        </Typography>
      </Box>
    );
  }

  return children;
};

export default CacheProvider; 